(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdc-studio-grid"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('pdc-studio-rail')){
 class PdcStudioRail extends HTMLElement{
  connectedCallback(){
   this.track=this.querySelector('.pdc-s-rail');if(!this.track)return;
   this.previous=this.querySelector('[data-rail-direction="-1"]');this.next=this.querySelector('[data-rail-direction="1"]');this.controls=this.querySelector('.pdc-s-rail-controls');
   this.onScroll=()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.update());};
   this.onClick=e=>{const button=e.target.closest('[data-rail-direction]');if(button&&this.contains(button))this.move(Number(button.dataset.railDirection));};
   this.onKey=e=>{if(e.target!==this.track)return;if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();this.move(e.key==='ArrowRight'?1:-1);}else if(e.key==='Home'||e.key==='End'){e.preventDefault();this.track.scrollTo({left:e.key==='Home'?0:this.track.scrollWidth,behavior:'instant'});}};
   this.track.addEventListener('scroll',this.onScroll,{passive:true});this.addEventListener('click',this.onClick);this.track.addEventListener('keydown',this.onKey);
   this.onPointerDown=e=>{
    if(e.pointerType!=='mouse'||e.button!==0||e.target.closest('button,input,select,textarea'))return;
    this.suppressClick=false;clearTimeout(this.clickTimer);
    this.drag={id:e.pointerId,x:e.clientX,y:e.clientY,left:this.track.scrollLeft,moved:false};
   };
   this.onPointerMove=e=>{
    const drag=this.drag;if(!drag||e.pointerId!==drag.id)return;
    if(!(e.buttons&1)){this.endDrag();return;}
    const dx=e.clientX-drag.x,dy=e.clientY-drag.y;
    if(!drag.moved){
     if(Math.abs(dx)<8)return;
     if(Math.abs(dy)>Math.abs(dx)){this.drag=null;return;}
     drag.moved=true;this.track.classList.add('is-dragging');this.track.setPointerCapture(e.pointerId);
    }
    e.preventDefault();this.track.scrollLeft=drag.left-dx;
   };
   this.onPointerEnd=e=>{if(this.drag&&e.pointerId===this.drag.id)this.endDrag();};
   this.onDragStart=e=>{if(this.drag)e.preventDefault();};
   this.onDragClick=e=>{if(this.suppressClick){e.preventDefault();e.stopImmediatePropagation();this.suppressClick=false;}};
   this.track.addEventListener('pointerdown',this.onPointerDown);
   this.track.addEventListener('pointermove',this.onPointerMove);
   this.track.addEventListener('pointerup',this.onPointerEnd);
   this.track.addEventListener('pointercancel',this.onPointerEnd);
   this.track.addEventListener('lostpointercapture',this.onPointerEnd);
   this.track.addEventListener('dragstart',this.onDragStart);
   this.track.addEventListener('click',this.onDragClick,true);
   this.resize=new ResizeObserver(()=>this.update());this.resize.observe(this.track);this.update();
  }
  endDrag(){
   const drag=this.drag;if(!drag)return;this.drag=null;
   if(drag.moved){this.suppressClick=true;this.clickTimer=setTimeout(()=>{this.suppressClick=false;},350);}
   if(this.track.hasPointerCapture(drag.id))this.track.releasePointerCapture(drag.id);
   this.track.classList.remove('is-dragging');this.update();
  }
  move(direction){const card=this.track.querySelector('.pdc-s-card');if(!card)return;const step=card.getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).columnGap||0);this.track.scrollBy({left:direction*step,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
  update(){const maximum=this.track.scrollWidth-this.track.clientWidth;this.controls.hidden=maximum<=2;this.previous.disabled=this.track.scrollLeft<=2;this.next.disabled=this.track.scrollLeft>=maximum-2;}
  disconnectedCallback(){if(!this.track)return;this.endDrag();clearTimeout(this.clickTimer);this.track.removeEventListener('pointerdown',this.onPointerDown);this.track.removeEventListener('pointermove',this.onPointerMove);this.track.removeEventListener('pointerup',this.onPointerEnd);this.track.removeEventListener('pointercancel',this.onPointerEnd);this.track.removeEventListener('lostpointercapture',this.onPointerEnd);this.track.removeEventListener('dragstart',this.onDragStart);this.track.removeEventListener('click',this.onDragClick,true);this.resize?.disconnect();cancelAnimationFrame(this.frame);this.track.removeEventListener('scroll',this.onScroll);this.removeEventListener('click',this.onClick);this.track.removeEventListener('keydown',this.onKey);}
 }
 customElements.define('pdc-studio-rail',PdcStudioRail);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl--announcement-banner-4"] && !Shopify.designMode) return;
  try {
    
const duplicateBannerContent = () => {
  const parents = document.querySelectorAll('[banner-data="parent"]');
  
  if (parents.length === 0) return;
  
  for (const parent of parents) {
    const child = parent.querySelector('[banner-data="duplicate"]');
    if (!child) continue;
    
    if (parent.children.length >= 2) continue;
    
    const duplicate = child.cloneNode(true);
    parent.appendChild(duplicate);
  }
};

// Handle initial load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', duplicateBannerContent);
} else {
  duplicateBannerContent();
}

// Handle theme editor changes
document.addEventListener('shopify:section:load', duplicateBannerContent);
document.addEventListener('shopify:section:reorder', duplicateBannerContent);

  } catch(e) { console.error(e); }
})();
})();
